export default {
  computed: {
    isAdmin() {
      return this.$store.getters.isOrgAdmin;
    },
    hasPlan() {
      return !!this.$store.getters.userData.plan;
    },
    planName() {
      if (!this.hasPlan) {
        return 'FREE';
      }

      return this.$store.getters.userData.plan[0].toUpperCase() + this.$store.getters.userData.plan.slice(1);
    }
  },

  methods: {
    isMyEmail(email) {
      return this.$store.getters.userData.email.trim().toLowerCase() === email.trim().toLowerCase();
    }
  }
}